/**
 * @typedef {{id:number,label:string,value:string|number}} DicItem
 */
const tagType = [
  { id: 0, label: "知药客", value: "1" },
  { id: 1, label: "知药管家", value: "2" },
  { id: 2, label: "资讯站", value: "3" },
  { id: 3, label: "小程序", value: "4" }
];
const subjectType = [
  { id: 0, label: "问答消费", value: "1" },
  { id: 1, label: "打赏大咖", value: "2" },
  { id: 2, label: "文章购买", value: "3" },
  { id: 3, label: "课程购买", value: "4" },
  { id: 4, label: "提现", value: "5" },
  { id: 5, label: "充值", value: "6" },
  { id: 6, label: "活动支付", value: "7" },
  { id: 7, label: "旧版本", value: "99" },
  { id: 8, label: "问答包购买", value: "8" },
  { id: 9, label: "其他", value: "9" },
  { id: 10, label: "打包购买", value: "10" },
  { id: 11, label: "杂货铺", value: "11" }
];
const questionLocation = [
  { id: 0, label: "问答包", value: "2" },
  { id: 1, label: "问答中", value: "1" },
  { id: 2, label: "都存在", value: "99" }
];
const questionSource = [
  { id: 0, label: "问答", value: "1" },
  { id: 1, label: "问答包", value: "2" }
];
const activityType = [
  { id: 0, label: "助力活动", value: "1" },
  { id: 1, label: "问答活动", value: "2" },
  { id: 2, label: "知药学院拉新", value: "3" },
  { id: 3, label: "拉新活动", value: "5" },
  { id: 4, label: "优惠券活动", value: "6" },
  { id: 5, label: "抽奖活动", value: "7" }
];
const channelType = [
  { id: 0, label: "APP", value: "1" },
  { id: 1, label: "外部", value: "2" },
  { id: 2, label: "APP+外部", value: "3" },
  { id: 3, label: "小程序", value: "4" }
];
const freeStatus = [
  { id: 0, label: "是", value: "0" },
  { id: 1, label: "否", value: "1" }
];
const resourceSwapTag = [
  { id: 0, label: "寻医", value: "1" },
  { id: 1, label: "学分/学术/PS", value: "2" },
  { id: 2, label: "求购", value: "3" },
  { id: 3, label: "转售/出货", value: "4" },
  // { id: 4, label: "出货", value: "5" },
  { id: 5, label: "招商", value: "6" },
  // { id: 6, label: "学术", value: "7" }
  { id: 7, label: "其他", value: "99" }
];
const publicStatus = [
  { id: 0, label: "非公开", value: "0" },
  { id: 1, label: "公开", value: "1" }
];
const refundStatus = [
  { id: 0, label: "部分退款", value: "1" },
  { id: 1, label: "全额退款", value: "2" },
  { id: 2, label: "未退款", value: "-1" }
];
const commentStatus = [
  { id: 0, label: "启用", value: "1" },
  { id: 1, label: "禁用", value: "0" }
];
const normalStatus = [
  { id: 0, label: "启用", value: "1" },
  { id: 1, label: "停用", value: "0" }
];
const bannerType = [
  { id: 0, label: "首页轮播图", value: "0" },
  { id: 1, label: "资讯早报轮播图", value: "1" },
  { id: 2, label: "红头文件轮播图", value: "2" },
  { id: 3, label: "活动", value: "3" },
  { id: 4, label: "快讯默认图", value: "4" },
  { id: 5, label: "小程序广告位", value: "5" },
  { id: 6, label: "app知药学院广告位", value: "6" },
  { id: 7, label: "app浮窗控制", value: "7" },
  { id: 8, label: "小程序知药学院广告位", value: "8" },
  { id: 9, label: "小程序浮窗控制", value: "9" }
];
const resourceSwapType = [
  // { id: 0, label: "是否公开", value: "publicFlag" },
  { id: 1, label: "是否推荐", value: "recommendFlag" },
  { id: 2, label: "是否置顶", value: "topFlag" },
  { id: 3, label: "是否首页推荐", value: "indexRecommendFlag" },
  { id: 4, label: "是否禁用", value: "disableFlag" }
];
const cooperationStatus = [
  { id: 0, label: "合作", value: '3' },
  { id: 1, label: "不合作", value: '2' },
  { id: 2, label: "未联系", value: '1' }
];
const courier = [
  { id: 1, label: "顺丰", value: "1" },
  { id: 2, label: "申通", value: "2" },
  { id: 3, label: "韵达", value: "3" },
  { id: 4, label: "圆通", value: "4" },
  { id: 5, label: "邮政", value: "5" },
  { id: 6, label: "中通", value: "6" },
  { id: 7, label: "德邦快递", value: "7" },
  { id: 8, label: "德邦物流", value: "8" },
  { id: 9, label: "京东物流", value: "9" },
  { id: 10, label: "极兔速递", value: "10" }
];
const priceType = [
  { id: 1, label: "限免", value: "1" },
  { id: 2, label: "促销", value: "2" },
  { id: 3, label: "原价", value: "3" },
  { id: 4, label: "免费", value: "4" }
];
const bidRecordSearch = [
  { id: 1, label: "新记录", value: "1" },
  { id: 2, label: "所有接单记录", value: "2" }
];
const commentSearch = [
  { id: 1, label: "新留言", value: "1" },
  { id: 2, label: "所有留言记录", value: "2" }
];
const tagLevel = [
  { id: 0, value: "1", label: "一级" },
  { id: 1, value: "2", label: "二级" }
];
const tf = [
  { id: 0, label: "是", value: "1" },
  { id: 1, label: "否", value: "0" }
];
const payMethods = [
  { id: 0, label: "余额支付", value: "1" },
  { id: 1, label: "支付宝", value: "2" },
  { id: 2, label: "微信", value: "3" }
];
const spellGroupStatus = [
  { id: 0, label: "拼团中", value: "1" },
  { id: 1, label: "拼团成功", value: "2" },
  { id: 2, label: "拼团失败", value: "3" }
];
const releaseStatus = [
  { id: 0, value: "1", label: "发布" },
  { id: 1, value: "2", label: "撤销" }
];
const disableFlagStatus = [
  { id: 0, label: "启用", value: "0" },
  { id: 1, label: "禁用", value: "1" }
];
const commodityStatus = [
  { id: 0, label: "等待上架", value: "1" },
  { id: 1, label: "上架", value: "2" },
  { id: 2, label: "下架", value: "3" }
];
const recommendationMode = [
  { id: 0, label: "首页推荐", value: "2" },
  { id: 1, label: "置顶推荐", value: "1" }
];
const discountRangeMode = [
  { id: 0, label: "所有商品", value: 1 },
  { id: 1, label: "特定商品", value: 2 }
];
const discountStatus = [
  { id: 0, label: "未开始", value: "1" },
  { id: 1, label: "生效中", value: "2" },
  { id: 2, label: "结束", value: "3" }
];
const preferentialMode = [
  { id: 0, label: "满额减钱", value: 1 },
  { id: 1, label: "满件减钱", value: 2 },
  { id: 2, label: "满额打折", value: 3 },
  { id: 3, label: "满件打折", value: 4 }
];
const orderStatus = [
  { id: 0, label: '成功', value: '1' },
  { id: 1, label: '失败', value: '2' },
  { id: 2, label: '处理中', value: '3' }
];
/**
 * 默认导出的字典对象
 * @type {{[key:string]:DicItem[]}}
 */
const exportObject = {
  tagType,
  subjectType,
  questionLocation,
  activityType,
  channelType,
  freeStatus,
  questionSource,
  resourceSwapTag,
  publicStatus,
  refundStatus,
  commentStatus,
  tf,
  bannerType,
  resourceSwapType,
  cooperationStatus,
  courier,
  priceType,
  bidRecordSearch,
  commentSearch,
  tagLevel,
  normalStatus,
  payMethods,
  spellGroupStatus,
  releaseStatus,
  disableFlagStatus,
  commodityStatus,
  recommendationMode,
  discountRangeMode,
  discountStatus,
  preferentialMode,
  orderStatus
};
export default exportObject;
function hasKey(key) {
  if (typeof key != "string") return false;
  return Object.keys(exportObject).indexOf(key) !== -1;
}
/**
 * 使用字典与值获取label 常用于filter
 * @param {string} value 字典中的值
 * @param {DicItem[]|string} dic 字典 字典名或字典实例
 * @param {string} defaultValue 默认值
 * @returns {String}
 */
export function getLabelByValue(value, dic, defaultValue) {
  if (dic) {
    let target = [];
    if (Array.isArray(dic)) {
      target = [...dic];
    } else if (hasKey(dic)) {
      target = exportObject[dic];
    } else {
      throw Error("使用了未定义的字典");
    }
    let temp = target.filter(v => v.value == value)[0];
    console.log(target, value, temp);
    if (temp) {
      return temp.label;
    } else if (defaultValue != undefined) {
      return defaultValue;
    }
  }
  return value;
}
const dicComponentMixin = {
  inheritAttrs: false,
  props: {
    dic: {
      type: String,
      validator(value) {
        return hasKey(value);
      }
    },
    dicArray: {
      type: Array
    }
  },
  computed: {
    iDic() {
      if (this.dicArray) {
        return this.dicArray;
      } else {
        return exportObject[this.dic];
      }
    }
  },
};
/**
 * 使用字典的select组件 
 * @type {Vue.Component} */
export const dicSelect = {
  name: "dic-select",
  mixins: [dicComponentMixin],
  props: {
    hasAll: {
      type: Boolean,
      default: false
    },
    allValue: {
      type: String,
      default: ""
    },
    allLabel: {
      type: String,
      default: "全部"
    },
  },
  template: `<el-select
    v-bind="$attrs"
    v-on:input="$emit('input',$event)"
    v-on:change="$emit('change', $event)"
    v-on:blur="$emit('blur', $event)"
  >
    <el-option
      v-if="hasAll"
      :value="allValue"
      :label="allLabel"
    />
    <slot name="head"></slot>
    <el-option
      v-for="item in iDic"
      :key="item.key"
      :value="item.value"
      :label="item.label"
    ></el-option>
    <slot name="foot"></slot>
  </el-select>`
};

/**
 * 使用字典的el-table-column组件 
 * @type {Vue.Component} */
export const dicTableColumn = {
  name: "dic-table-column",
  mixins: [dicComponentMixin],
  props: {
    defaultValue: {
      type: String,
      default: ""
    },
  },
  methods: {
    formatter(_row, _column, cellValue) {
      return getLabelByValue(cellValue, this.iDic, this.defaultValue);
    }
  },
  template: `<el-table-column :formatter="formatter" v-bind="$attrs" >
    <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data"></slot>
    </template>
  </el-table-column>`
};
/** @type {keyof exportObject} */
/**
 * 使用字典的el-radio-group自口岸
 * @type {Vue.Component}
 */
export const dicRadioGroup = {
  name: "dic-radio-group",
  mixins: [dicComponentMixin],
  props: {
  },
  methods: {},
  template: `<el-radio-group
    v-bind="$attrs"
    v-on:input="$emit('input',$event)"
    v-on:change="$emit('change', $event)"
    v-on:blur="$emit('blur', $event)"
  >
    <el-radio
      v-for="item in iDic"
      :key="item.key"
      :label="item.value">{{item.label}}</el-radio>
  </el-radio-group>`
};


// WEBPACK FOOTER //
// ./src/dictionary/dictionary.js